import { useContext } from "react";

import AuthContext, { AuthContextInterface } from "../context/auth";

const useAuth = (): AuthContextInterface => useContext(AuthContext);

export default useAuth;
